'use client';
import React from 'react';
import { AnalyticsPageView } from '@nerdwallet-cards/analytics';

import { HeaderSection } from './header-section';
import { InsightsSection } from './insights-section';
import { HowDoesItWorkSection } from './how-does-it-work-section';
import { PersonalizedRecommendationsSection } from './personalized-recommendations-section';
import {
  useImpressionEvent,
  useInitializeGtm,
  useUserNavigatedEvent,
} from 'src/utils/analytics/hooks';
import { useAppSelector } from 'src/redux/hooks';
import { getIsSignedIn } from 'src/redux/selectors';
import { EntityName, EventType } from 'src/utils/analytics/constants';
import { BrandedLPAnalyticsProvider } from './context';
import { PartnersSection } from './partners-section';
import { BottomInsightsSection } from './bottom-insights-section';
import { SatellitePageViewRegistration } from '../../components/SatellitePageViewRegistration';

const BrandedLp = () => {
  const { navigationId } = useUserNavigatedEvent();
  const isSignedIn = useAppSelector(getIsSignedIn);

  useInitializeGtm({
    isSignedIn,
    navigationId,
  });

  const { impressionId } = useImpressionEvent({
    eventType: EventType.PageImpression,
    immediate: true,
    navigationId,
    payload: {
      entity_name: EntityName.Jump,
    },
  });

  if (!navigationId || !impressionId) return null;

  const analytics = {
    navigationId,
    impressionId,
  };

  return (
    <BrandedLPAnalyticsProvider analytics={analytics}>
      <AnalyticsPageView name={EntityName.Jump}>
        <SatellitePageViewRegistration>
          <HeaderSection />
          <InsightsSection />
          <HowDoesItWorkSection />
          <PersonalizedRecommendationsSection />
          <PartnersSection />
          <BottomInsightsSection />
        </SatellitePageViewRegistration>
      </AnalyticsPageView>
    </BrandedLPAnalyticsProvider>
  );
};

export default BrandedLp;
